<script>
export default {
  name: 'AppModal'
};
</script>

<template>
  <modal v-bind="$attrs" v-on="$listeners" height="auto">
    <div>
      <h3 class="vue-dialog-content-title">
        <slot name="title" />
        <button @click="$emit('close')" class="close-button">
          <app-icon type="font" name="close-outline" class="close-icon" />
        </button>
      </h3>
      <div class="vue-dialog-contents">
        <slot name="content" />
      </div>
      <div class="vue-dialog-buttons" v-if="$slots.buttons">
        <div class="buttons-container">
          <button type="button" @click="$emit('close')" class="button-cancel">Cancel</button>
          <slot name="buttons" />
        </div>
      </div>
    </div>
  </modal>
</template>

<style lang="scss">
// !important: this is GLOBAL styling which is also used for the vue-dialog component
// This is why Tailwind is not used here at the moment
.vm--container {
  .vm--overlay {
    background: #1e2240be;
  }

  .vm--modal {
    padding: 0;
    border-radius: 18px;
    box-shadow: 0 6px 23px #071c4e33;

    .vue-dialog-contents {
      padding: 28px;
    }

    .vue-dialog-content {
      padding: 0;
      font-size: 15px;
      line-height: 20px;
      font-weight: 500;
      color: var(--primary-color);

      .content {
        padding: 36px 28px;
      }
    }

    .vue-dialog-content-title {
      color: var(--primary-color);
      font-size: 22px;
      font-weight: 800;
      padding: 28px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f0f0f5;

      .close-button {
        display: flex;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }

      .close-icon {
        font-size: 34px;
        font-weight: bold;
        color: var(--purple-light-3);
      }

      .bold-title {
        font-size: 22px;
      }
    }

    .vue-dialog-buttons {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      padding: 28px;
      border-top: 1px solid #f0f0f5;

      .buttons-container {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
        width: 100%;
      }

      .button-cancel {
        padding: 0 20px;
        color: var(--purple-light-3);
        box-shadow: 0px 2px 6px #a7aed966;
        border: 1px solid #ececf1;
        border-radius: 8px;
      }

      button {
        &:focus {
          outline: none;
        }
      }

      &.left {
        justify-content: flex-end;
      }
    }
  }
}
</style>
